import { useLocation } from 'wouter'
import { IconProps } from '../Icon/index.js'
import { ParsedTab, useNewCMS } from './index.js'
import { ReactNode, useEffect } from 'react'
import { Stack } from '../Stack/index.js'
import { Sidebar } from '../Sidebar/index.js'

export type NewCMSTabProps = {
  title: string
  icon?: IconProps['variant']
  path?: string
  children?: ReactNode
}

export function NewCMSTab(_: NewCMSTabProps) {
  return null
}

export function TabFallback({ tab }: { tab: ParsedTab }) {
  const cms = useNewCMS()
  const [loc] = useLocation()
  const first = tab.pages[0]?.nav
  const isIndex = loc === '' || loc === '/'

  useEffect(() => {
    if (isIndex) {
      cms.navigate(first ?? '/404', { replace: true })
    } else {
      cms.navigate('/404', { replace: true })
    }
  }, [loc])

  return null
}

export type TabLayoutProps = {
  tab: ParsedTab
  children: ReactNode
}

export function TabLayout({ tab, children }: TabLayoutProps) {
  const cms = useNewCMS()

  const groups: Array<{
    title?: string
    pages: Array<{
      id: string
      title: string
      nav: string
      icon?: IconProps['variant']
      counter?: number
      group?: string
    }>
  }> = []

  for (const page of tab.pages) {
    const title = page.group
    let group = groups.find((group) => group.title === title)

    if (!group) {
      group = { title, pages: [] }
      groups.push(group)
    }

    group.pages.push({
      id: page.id,
      title: page.title,
      nav: page.nav,
      group: page.group,
      icon: page.icon,
      counter: page.counter,
    })
  }

  return (
    <Stack
      direction="column"
      justify="start"
      align="start"
      style={{ flex: 1, height: '100%', width: '100%', padding: 16 }}
    >
      <Stack
        gap={16}
        direction="row"
        justify="start"
        align="start"
        style={{ height: '100%', width: '100%' }}
      >
        <Sidebar value={cms.location} onChange={cms.navigate}>
          <Sidebar.Items>
            {groups.map((group, index) => {
              return (
                <Sidebar.Group key={group.title + index} title={group.title}>
                  {group.pages.map((page, index) => {
                    return (
                      <Sidebar.Item
                        key={page.id + index}
                        value={page.nav}
                        icon={page.icon}
                        counter={page.counter}
                      >
                        {page.title}
                      </Sidebar.Item>
                    )
                  })}
                </Sidebar.Group>
              )
            })}
          </Sidebar.Items>
        </Sidebar>

        {children}
      </Stack>
    </Stack>
  )
}
